import classNames from 'classnames';
import * as React from 'react';
import { useVoiceboxSchema } from 'vet-bones/components/molecules/Voicebox';
import { VoiceboxLaunchIcon } from 'vet-bones/design-system/components';

import { useMosaicView } from 'src/components/mosaic/MosaicViewContextProvider';
import { ProjectTileId } from 'src/constants/mosaic';
import { projectVoiceboxSummaryIssuesSelector } from 'src/selectors/projectVoiceboxSummaryIssues';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectSidebarVoiceboxButton: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const { projectId } = useRouterParams();
  const mosaicViewProps = useMosaicView();
  const { testIds } = useVoiceboxSchema();

  const { count } = useReduxSelector(
    projectVoiceboxSummaryIssuesSelector(projectId)
  );

  const isVoiceboxOpen = useReduxSelector(
    (state) => state.ui.isVoiceboxDrawerOpen
  );

  const isSidebarCollapsed = React.useMemo(() => {
    if (!mosaicViewProps) {
      return false;
    }
    const { collapsedById } = mosaicViewProps;
    const sidebarCollapsed = collapsedById[ProjectTileId.SIDEBAR];
    return Boolean(sidebarCollapsed);
  }, [mosaicViewProps]);

  const handleClick = React.useCallback(() => {
    if (isSidebarCollapsed) {
      mosaicViewProps?.restoreInitialSplit();
      if (isVoiceboxOpen) {
        return;
      }
    }
    dispatch(
      uiSlice.actions.toggledVoiceboxDrawer({
        isOpen: !isVoiceboxOpen,
      })
    );
  }, [dispatch, isSidebarCollapsed, isVoiceboxOpen, mosaicViewProps]);

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      className={classNames('vb-voicebox-drawer-button-container', {
        'vb-voicebox-drawer-button-container--hidden':
          !isSidebarCollapsed && isVoiceboxOpen,
      })}
    >
      <a
        className="vb-voicebox-drawer-button"
        data-testid={testIds.voiceboxButton}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        role="button"
        tabIndex={0}
      >
        <VoiceboxLaunchIcon
          hover={isHovered}
          size={70}
          text={count ? count.toString() : undefined}
        />
      </a>
    </div>
  );
};
